module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step0_Titlecard.25e5e017.webp";